import { LayerData } from './layer.data';
import { TintableLayerData } from './tintable-layer.data';

export class ShapeLayerData extends TintableLayerData {

  /**
   * Contructor
   */
  constructor(color: string, x:number=0, y:number=0, width:number=NaN, height:number=NaN, rotation:number=0, alpha:number=1, locks:any=null, source:string="CreationLayer", special:string = null) {
    super(color, x, y, width, height, rotation, alpha, locks, source, special);
			
		this.type = LayerData.SHAPE;
  }
  
}
